import { ArrowDownAZ, TriangleAlert } from 'lucide-react';
import { DialogDescription } from '@/components/ui/dialog';
import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';
import { Typography, typographyVariants } from '@/components/ui/typography';

export const missingCaptionsTitle = (count: number): string =>
  count === 1
    ? '1 Photo Is Missing a Caption'
    : `${count} Photos Are Missing a Caption`;

interface CaptionSortMissingCaptionsDialogProps {
  missingCount: number;
  onSortAnyway: () => void;
  onGoBack: () => void;
}

/**
 * DV-3537: the warning before a Caption Sort that would sink uncaptioned
 * photos to the end of the set. Copy is the design's. "Go Back & Add
 * Captions" just closes (decided 2026-10-09) — Escape, the backdrop and the
 * corner X do the same.
 */
const CaptionSortMissingCaptionsDialog = ({
  missingCount,
  onSortAnyway,
  onGoBack
}: CaptionSortMissingCaptionsDialogProps) => (
  <Modal
    open
    onOpenChange={(next) => {
      if (!next) onGoBack();
    }}
    size="md"
    title={
      <span className="flex items-center gap-3">
        <span
          aria-hidden="true"
          className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-warning-soft text-warning-soft-foreground"
        >
          <TriangleAlert className="h-5 w-5" />
        </span>
        {missingCaptionsTitle(missingCount)}
      </span>
    }
    footer={
      <>
        <Button type="button" variant="outline" onClick={onGoBack} autoFocus>
          Go Back &amp; Add Captions
        </Button>
        <Button type="button" onClick={onSortAnyway}>
          <ArrowDownAZ className="h-4 w-4" />
          Sort Anyway
        </Button>
      </>
    }
  >
    <div className="flex flex-col gap-3">
      {/* The dialog's description (aria-describedby): what the sort will do
          to those photos is the point of the warning. Styled as the body
          paragraph below it, not as a header description. */}
      <DialogDescription
        className={typographyVariants({
          variant: 'body',
          className: 'text-muted-foreground'
        })}
      >
        Caption Sort places photos without a caption at the end of the photo
        set.
      </DialogDescription>
      <Typography as="p" variant="body" className="text-muted-foreground">
        Go back to add captions first, or continue sorting now.
      </Typography>
    </div>
  </Modal>
);

export default CaptionSortMissingCaptionsDialog;
